import React from 'react';

import './Bullet.scss';

const Bullet = props => {
    const BulletClass = [
        'Bullet', 
        props.score === 100 ? "Bullet--1" : 'Bullet--2',
    ];
    const AltText = [
        props.score === 100 ?'On track': "Opportunity for improvement" ,
    ];

    return (
        <li className={BulletClass.join(' ')}>
            <div className="Bullet__header">
                <div className="Bullet__radio Bullet__radio--1"></div>
                <h3 className="Bullet__title">{props.title}<span className="sr-only">{AltText}</span></h3>
            </div>
            <div className="Bullet__copy">
                <div className="Bullet__copy--main">
                    {props.mainN}
                </div>
            </div>
        </li>
    )
}

export default Bullet;